/* UNMODIFIED */
export enum OpportunityStatus {
	open = 0,
    won = 1,
    lost = 2,
    closedUnknown = -1,
}